/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try increasing the budget cap or removing expensive locked picks`)
};

const es_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intenta aumentar el presupuesto máximo o eliminar selecciones bloqueadas costosas`)
};

const de_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhöhe das Budgetlimit oder entferne teure gesperrte Auswahlen`)
};

const nl_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhoog het budgetlimiet of verwijder dure vergrendelde keuzes`)
};

const fr_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayez d’augmenter le plafond budgétaire ou de retirer des sélections verrouillées coûteuses`)
};

const it_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova ad aumentare il tetto di budget o rimuovere selezioni bloccate costose`)
};

const pt_br2_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente aumentar o teto de orçamento ou remover seleções fixadas caras`)
};

const pt_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente aumentar o teto de orçamento ou remover seleções fixadas caras`)
};

const ja_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予算上限を上げるか、高額のロック選択を削除してください`)
};

const zh_f1_apex_increase_budget = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尝试提高预算上限或移除昂贵的锁定选择`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_increase_budget = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_increase_budget(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_increase_budget", locale)
	if (locale === "en") return en_f1_apex_increase_budget(inputs)
	if (locale === "es") return es_f1_apex_increase_budget(inputs)
	if (locale === "de") return de_f1_apex_increase_budget(inputs)
	if (locale === "nl") return nl_f1_apex_increase_budget(inputs)
	if (locale === "fr") return fr_f1_apex_increase_budget(inputs)
	if (locale === "it") return it_f1_apex_increase_budget(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_increase_budget(inputs)
	if (locale === "pt") return pt_f1_apex_increase_budget(inputs)
	if (locale === "ja") return ja_f1_apex_increase_budget(inputs)
	return zh_f1_apex_increase_budget(inputs)
};